import { render, staticRenderFns } from "./EsctRates.vue?vue&type=template&id=2f33f408&scoped=true&"
import script from "./EsctRates.vue?vue&type=script&lang=js&"
export * from "./EsctRates.vue?vue&type=script&lang=js&"
import style0 from "./EsctRates.vue?vue&type=style&index=0&id=2f33f408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33f408",
  null
  
)

export default component.exports